
import React from 'react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description: 'Comprehensive health assessment including medical history, current symptoms, and wellness goals to determine the optimal NAD+ protocol.',
      icon: 'ri-user-heart-line'
    },
    {
      number: '02',
      title: 'Biomarker Testing',
      description: 'Advanced laboratory testing to measure current NAD+ levels, cellular function markers, and overall health status.',
      icon: 'ri-test-tube-line'
    },
    {
      number: '03',
      title: 'Treatment Planning',
      description: 'Personalized NAD+ protocol design including dosage, delivery method, and treatment schedule based on your unique needs.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '04',
      title: 'First Treatment',
      description: 'Begin your NAD+ therapy in our comfortable treatment rooms with full medical supervision and monitoring.',
      icon: 'ri-hospital-line'
    },
    {
      number: '05',
      title: 'Progress Monitoring',
      description: 'Regular follow-ups to track your response, adjust protocols, and ensure optimal benefits from your NAD+ therapy.',
      icon: 'ri-line-chart-line'
    },
    {
      number: '06',
      title: 'Maintenance Protocol',
      description: 'Ongoing NAD+ therapy schedule designed to maintain optimal cellular function and long-term health benefits.',
      icon: 'ri-calendar-check-line'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Your <strong>NAD+ Therapy</strong> Journey
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our comprehensive approach ensures you receive the most effective NAD+ treatment tailored to your unique cellular needs.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start space-x-4 lg:space-x-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-r from-green-600 to-green-700 rounded-2xl flex items-center justify-center">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center mb-2">
                  <span className="text-sm font-bold text-green-600 bg-green-100 px-3 py-1 rounded-full mr-3">
                    {step.number}
                  </span>
                  <h3 className="text-xl lg:text-2xl font-bold text-gray-900">
                    {step.title}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
          <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 text-center">
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">24-48 Hours</div>
              <div className="text-gray-600">Initial Energy Boost</div>
            </div>
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">1-2 Weeks</div>
              <div className="text-gray-600">Sustained Benefits</div>
            </div>
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">Ongoing</div>
              <div className="text-gray-600">Cellular Optimization</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
